export const VISIT_SUBSCRIPTION_PAGE = 'VISIT_SUBSCRIPTION_PAGE'
export const UNSET_SUBSCRIPTION_VISIT = 'UNSET_SUBSCRIPTION_VISIT'
export const SELECT_SUBSCRIPTION_PLAN = 'SELECT_SUBSCRIPTION_PLAN'
